/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Requests_Chart_LabelInputs */

const en_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`requests per week over the last ${i?.count} weeks`)
};

const zh_hans1_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`近 ${i?.count} 周每周请求数`)
};

const pt_br2_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`requisições por semana nas últimas ${i?.count} semanas`)
};

const es_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`solicitudes por semana en las últimas ${i?.count} semanas`)
};

const fr_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`requêtes par semaine sur les ${i?.count} dernières semaines`)
};

const de_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anfragen pro Woche in den letzten ${i?.count} Wochen`)
};

const ru_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`запросов в неделю за последние недель: ${i?.count}`)
};

const it_measure_requests_chart_label = /** @type {(inputs: Measure_Requests_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`richieste a settimana nelle ultime ${i?.count} settimane`)
};

/**
* | output |
* | --- |
* | "requests per week over the last {count} weeks" |
*
* @param {Measure_Requests_Chart_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_requests_chart_label = /** @type {((inputs: Measure_Requests_Chart_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Requests_Chart_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_requests_chart_label(inputs)
	if (locale === "pt-BR") return pt_br2_measure_requests_chart_label(inputs)
	if (locale === "es") return es_measure_requests_chart_label(inputs)
	if (locale === "fr") return fr_measure_requests_chart_label(inputs)
	if (locale === "de") return de_measure_requests_chart_label(inputs)
	if (locale === "ru") return ru_measure_requests_chart_label(inputs)
	if (locale === "it") return it_measure_requests_chart_label(inputs)
	return en_measure_requests_chart_label(inputs)
});